<div class="input" [class.input--disabled]="disabled">
  @if (label) {
  <span class="input__label">
    {{ label | translate }}
    @if (isRequired && !disabled) {
    <span class="color--red">*</span>
    }
  </span>
  }

  <ng-container [ngSwitch]="type">
    <textarea
      *ngSwitchCase="FormInputType.Textarea"
      #txtAreaInput
      class="input__control input__control--textarea"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [attr.maxlength]="maxLength"
      [rows]="4"
      [value]="value"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"></textarea>

    <input
      *ngSwitchDefault
      #defaultInput
      class="input__control"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="formatInputValue(value)"
      [attr.maxlength]="maxLength"
      [attr.min]="type === FormInputType.Number ? 0 : null"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"/>
  </ng-container>

  @if (hint) {
  <span class="input__hint">{{ hint | translate }}</span>
  }

  @if (isOverMaxLength) {
  <span class="input__label">
    <span class="color--red">
      {{
        ("webPos.General.MaxLengthPrefix" | translate) +
          maxLength +
          ("webPos.General.MaxLengthSuffix" | translate)
      }}
    </span>
  </span>
  }
</div>
